// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2wcPB","inner":"Form_inner__3GZsi","range":"Form_range__1eH2S","name":"Form_name__UJSeZ","actions":"Form_actions__3NI5d"};